import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import MODALS from 'constants/modals';
import fetch from 'features/common/fetch';
import guarantors from 'features/views/campaignSettings/guarantors';
import formDescriptorFn, { EDIT_GUARANTOR_FORM_NAME } from 'features/views/campaignSettings/guarantors/form';

import GuarantorsCard from './components/GuarantorsCard';
import EditGuarantorModal from './modals/EditGuarantorModal';

export const Guarantors = ({ campaignId }) => {
	const dispatch = useDispatch();

	const regions = useSelector(guarantors.selectors.getRegions);

	useEffect(() => {
		dispatch(guarantors.actions.fetchRegions(campaignId));
		// eslint-disable-next-line
	}, [dispatch]);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Form name={EDIT_GUARANTOR_FORM_NAME} formDescriptorFn={formDescriptorFn}>
				<EditGuarantorModal id={MODALS.edit_guarantor} />
			</Form>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('guarantors:header')} />
				<ComponentLoader fetchStorePath={fetch.constants.urls.campaignGuarantorRegion}>
					<Grid container>
						<Grid size={12}>
							<Grid container spacing={2}>
								{regions.map((region) => (
									<Grid key={region.id} size={4}>
										<GuarantorsCard region={region} campaignId={campaignId} />
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</ComponentLoader>
			</Stack>
		</Paper>
	);
};

Guarantors.propTypes = {
	campaignId: PropTypes.string,
};

export default Guarantors;
